<div class="mt-4">
    <div class="welcome-screen container-sm mt-5 pt-5">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div *ngIf="wrongRequestPersonSolcert && !wrongRequestPerson && !loading"
                     class="alert alert-info mt-2"
                     role="alert">
                    <div class="row">
                        <div class="col-md-0">
                            <i class="fa fa-exclamation-circle fa-2x text-primary"></i>
                        </div>
                        <div class="col-md-10">
                            <div [innerHTML]="messageRequestSolcert | translate">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card shadow-lg p-5">
                    <div class="">
                        <div class="modal-header text-center">
                            <h4 class="modal-title title text-center">
                                <i class="fas fa-certificate"></i> {{"TITLE.COMPLETE-IMAGE-VALIDATION" | translate}}
                            </h4>
                        </div>
                    </div>
                    <div class="card-title text-center">
                        <p>{{"MESSAGE.NEED-ADD-IMAGES" | translate}}</p>
                    </div>
                    <div *ngIf="messageRequest !== '' && messageRequest !== undefined"
                         class="alert alert-success mt-2 text-center"
                         role="alert">
                        <i class="fa fa-exclamation-circle fa-2x text-success"></i>
                        {{messageRequest}}
                    </div>
                    <form [formGroup]="signatureForm">
                        <div class="row">
                            <div class="col">
                                <label for="obverseDNI"
                                       class="col-form-label font-weight-bold text-center">{{ "LABEL.FRONT-PART-OF-THE-IDENTIFICATION-DOCUMENT" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="image/jpeg, image/png"
                                           alife-file-to-base64
                                           id="obverseDNI"
                                           (change)="readSelectedDocumentFront($event)"
                                           (onFileChanged)="changeStatus($event)"
                                           [class.is-invalid]="isInvalidControl('documentFrontFilename2Show')">
                                    <small *ngIf="isInvalidControl('documentFrontFilename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.SELECT-IMAGE-OF-FRONT-OF-IDENTITY-DOCUMENT" | translate }}
                                    </small>
                                    <div class="custom-file-label">
                                        <label for="obverseDNI">
                                            {{signatureForm.get('documentFrontFilename2Show').value ? signatureForm.get('documentFrontFilename2Show').value : 'MESSAGE.SELECT-FILE' | translate}}
                                        </label>
                                    </div>
                                </div>


                                <label for="obverseDNI"
                                       class="col col-form-label text-center">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div class="text-center">
                                    <img [src]="defaultDocumentFrontSrc" #rubricPic
                                         alt="Rubric" class="img-custom">
                                </div>


                                <label for="backDNI"
                                       class="col-form-label font-weight-bold text-center">{{ "LABEL.REVERSE-SIDE-OF-IDENTIFICATION-DOCUMENT" | translate }}</label>
                                <div class="custom-file content-file">
                                    <input type="file"
                                           class="custom-file-input"
                                           accept="image/jpeg, image/png"
                                           alife-file-to-base64
                                           id="backDNI"
                                           (change)="readSelectedBackDNI($event)"
                                           (onFileChanged)="changeStatus2($event)"
                                           [class.is-invalid]="isInvalidControl('documentRearFilename2Show')">
                                    <small *ngIf="isInvalidControl('documentRearFilename2Show')"
                                           class="text-danger">
                                        {{ "MESSAGE.SELECT-IMAGE-OF-BACK-OF-IDENTITY-DOCUMENT" | translate }}
                                    </small>
                                    <div class="custom-file-label">
                                        <label for="backDNI">
                                            {{signatureForm.get('documentRearFilename2Show').value ? signatureForm.get('documentRearFilename2Show').value : ('MESSAGE.SELECT-FILE' | translate)}}
                                        </label>
                                    </div>
                                </div>


                                <label for="backDNI"
                                       class="col col-form-label text-center">{{ "LABEL.PREVIEW" | translate }}</label>
                                <div class="text-center">
                                    <img [src]="defaultDocumentRearSrc" #rubricPic class="img-custom"
                                         alt="Rubric">
                                </div>

                                <!-- Cargar archivos vigencia de poder-->
                                <div class="row"
                                     *ngIf="isCloudSignature  && needShowImages && needShowPowerValidityAndRucFile">
                                    <div class="col-md-9">
                                        <label for="file"
                                               class="col-form-label font-weight-bold text-center">{{ "LABEL.POWER-VALIDITY" | translate }}</label>
                                        <div class="custom-file content-file">
                                            <input type="file"
                                                   class="custom-file-input"
                                                   accept="application/pdf"
                                                   id="file"
                                                   alife-file-to-base64
                                                   (change)="readSelectedPWfile($event)"
                                                   (onFileChanged)="changeStatus1($event)"
                                                   [class.is-invalid]="isInvalidControl('filename2Show')">
                                            <small *ngIf="isInvalidControl('filename2Show')"
                                                   class="text-danger">
                                                {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
                                            </small>
                                            <div class="custom-file-label">
                                                <label for="file">
                                                    {{signatureForm.get('filename2Show').value ? signatureForm.get('filename2Show').value : ('MESSAGE.SELECT-FILE' | translate)}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="file"
                                               class="col-form-label text-center">{{ "LABEL.PREVIEW" | translate }}</label>
                                        <div>
                                            <button type="button"
                                                    [disabled]="!hasPowerValidity1"
                                                    class="btn btn-outline-success"
                                                    (click)="openModalPdfViewer(POWER_VALIDITY)">
                                                <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- ficha ruc-->
                                <div class="row"
                                     *ngIf="isCloudSignature  && needShowImages && needShowPowerValidityAndRucFile">
                                    <div class="col-md-9">
                                        <label for="rucFile"
                                               class="col-form-label font-weight-bold">{{ "LABEL.RUC-FILE" | translate }}</label>
                                        <div class="custom-file content-file">
                                            <input type="file"
                                                   class="custom-file-input"
                                                   accept="application/pdf"
                                                   id="rucFile"
                                                   alife-file-to-base64
                                                   (change)="readSelectedRFfile($event)"
                                                   (onFileChanged)="changeStatus3($event)"
                                                   [class.is-invalid]="isInvalidControl('rucFilename2Show')">
                                            <small *ngIf="isInvalidControl('rucFilename2Show')"
                                                   class="text-danger">
                                                {{ "MESSAGE.FILE-ARE-REQUIRED" | translate }}
                                            </small>
                                            <div class="custom-file-label">
                                                <label for="rucFile">
                                                    {{signatureForm.get('rucFilename2Show').value ? signatureForm.get('rucFilename2Show').value : ('MESSAGE.SELECT-FILE' | translate)}}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="file"
                                               class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                                        <div>
                                            <button type="button"
                                                    [disabled]="!hasRUCFile1"
                                                    class="btn btn-outline-success"
                                                    (click)="openModalPdfViewer(RUC_FILE)">
                                                <i class="fa fa-eye fz-24 custom-ml-12"></i> {{ "BUTTON.PREVIEW" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </form>
                    <br>
                    <div class="card-footer">
                        <div class="text-center">
                            <!--                            <button type="button"-->
                            <!--                                    class="btn btn-danger"-->
                            <!--                                    (click)="navigatePrincipalUrl()">-->
                            <!--                                <i class="fa fa-reply"></i> {{ "BUTTON.BACK" | translate }}-->
                            <!--                            </button>-->
                            &nbsp;
                            <button type="button"
                                    id="btnRequest"
                                    class="submit btn btn-success"
                                    (click)="requestCertificate()"
                                    [disabled]="requestCompleted">
                                <i class="fas fa-certificate"></i> {{ "BUTTON.REQUEST-CERTIFICATE" | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="loading"></app-loading>
